module.exports = __webpack_public_path__ + "static/media/ic_search.51150b66.svg";